Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_NAME = 'sentry.javascript.browser';
exports.SDK_VERSION = '5.30.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/dist/version.js
// module id = 361
// module chunks = 0